import { render, staticRenderFns } from "./category2.vue?vue&type=template&id=1c65dddd"
import script from "./category2.vue?vue&type=script&lang=js"
export * from "./category2.vue?vue&type=script&lang=js"
import style0 from "./category2.vue?vue&type=style&index=0&id=1c65dddd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports